var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIconBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5949 3.91158L13.0848 5.44288M12.5528 2.56257L8.5222 6.7051C8.31394 6.91884 8.17191 7.19117 8.114 7.48774L7.7417 9.40313L9.60532 9.01977C9.89387 8.96045 10.1585 8.81506 10.3668 8.60095L14.3974 4.45842C14.5185 4.33394 14.6146 4.18616 14.6801 4.02351C14.7457 3.86086 14.7794 3.68654 14.7794 3.5105C14.7794 3.33445 14.7457 3.16013 14.6801 2.99748C14.6146 2.83483 14.5185 2.68705 14.3974 2.56257C14.2763 2.43808 14.1325 2.33934 13.9742 2.27197C13.816 2.2046 13.6464 2.16992 13.4751 2.16992C13.3038 2.16992 13.1342 2.2046 12.9759 2.27197C12.8177 2.33934 12.6739 2.43808 12.5528 2.56257Z",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3719 10.85V13.02C13.3719 13.4037 13.2236 13.7717 12.9597 14.043C12.6957 14.3143 12.3377 14.4667 11.9644 14.4667H4.22275C3.84944 14.4667 3.49142 14.3143 3.22745 14.043C2.96348 13.7717 2.81519 13.4037 2.81519 13.02V5.06337C2.81519 4.67969 2.96348 4.31172 3.22745 4.04042C3.49142 3.76912 3.84944 3.6167 4.22275 3.6167H6.3341",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconBlack);
export default __webpack_public_path__ + "static/media/editIconBlack.c31754f2673915216c9cd30a7c9bbbef.svg";
export { ForwardRef as ReactComponent };